const createHWAgentErrorMessage = (err: any, title?: string) => {
    if (err.status === 500 || err.status === 400) {
        return `${title ? `${title} - ` : ''} ${
            err.data?.error ?? 'Error in HWAgent'
        }`
    }
    if ((err.status ?? 0) === 0)
        return 'Cannot connect to HWAgent. Please check your HWAgent Status'
    return 'Error in HWAgent'
}

export default createHWAgentErrorMessage
